'use es6';

import Log from 'forms-utils-lib/logger/Logger';
import { getDashboardRoute } from 'FormsCommonComponents/lib/RouteGenerators';
import { getForm } from 'FormsUI/api/LeadFlows';
import getSubmissionsUrl from 'FormsUI/utils/url/getSubmissionsUrl';
const RedirectLeadFlowsDetails = ({
  params: {
    leadFlowId
  }
}) => {
  getForm(leadFlowId).then(({
    formGuid
  }) => {
    window.location.href = getSubmissionsUrl(formGuid, null);
  }).catch(() => {
    Log.error(`Failed to get lead-flow ${leadFlowId}`);
    window.location.href = getDashboardRoute();
  });
};
export default RedirectLeadFlowsDetails;